import { Dialog, Stack, Typography, Box, IconButton } from "@mui/material";
import type { DialogProps } from "@mui/material";
import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Modal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
  title?: string | React.ReactElement<any> | number | string;
  titleAlignment?: "center" | "left";
  children: React.ReactElement<any> | number | string;
  sx?: { [key: string]: string };
  /**
   * Let the dialog size itself instead of being sized by its content. Pass
   * these and the child declares no width — a child that sets its own `vw`
   * width makes the panel size off the viewport and then scroll inside the
   * container. Both default to today's shrink-wrap behaviour so existing call
   * sites are unaffected.
   */
  fullWidth?: boolean;
  maxWidth?: DialogProps["maxWidth"];
}> = ({
  isOpen,
  handleClose,
  title,
  children,
  sx,
  titleAlignment = "center",
  fullWidth = false,
  maxWidth = false,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <Box sx={{ p: 4, ...sx }}>
        <Stack direction="row" sx={{ alignItems: "flex-start", mb: 3 }}>
          {typeof title === "string" ? (
            <Typography
              variant="h1"
              sx={{
                fontWeight: "bold",
                width: "100%",
                textAlign: "center",
                pl: 6,
                pr: 1
              }}>
              {title}
            </Typography>
          ) : (
            <Box
              sx={{
                width: "100%",
                pl: titleAlignment === "center" ? 5 : 0,
                pr: 1,
              }}
            >
              {title}
            </Box>
          )}
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon />
          </IconButton>
        </Stack>
        {children}
      </Box>
    </Dialog>
  );
};

export default Modal;
